import { render } from "./App.vue?vue&type=template&id=36201d08&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=36201d08&lang=css"
import "./App.vue?vue&type=style&index=1&id=36201d08&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36201d08"]])

export default __exports__